module.exports = __webpack_public_path__ + "img/1.b32cb125.jpg";